import { cva } from '@vizit/theme';
import { TabSize, TabVariant } from './types';

export const tabListClasses = cva({
  base: ['inline-flex items-center'],
  variants: {
    variant: {
      [TabVariant.Default]: 'h-22 rounded-none border border-secondary-alt bg-secondary-alt p-2 gap-4',
      [TabVariant.Button]: 'gap-2',
      [TabVariant.Underline]: 'w-full justify-center',
    },
  },
  defaultVariants: {
    variant: TabVariant.Default,
  },
});

export const tabClasses = cva({
  base: [
    'relative cursor-pointer font-semibold outline-none',
    'flex items-center justify-center gap-6',
    'disabled:cursor-not-allowed',
    'transition-all duration-200',
  ],
  variants: {
    variant: {
      [TabVariant.Default]: [
        'rounded-none border border-transparent',
        'text-quaternary',
        'hover:text-secondary',
        'data-[selected]:bg-white data-[selected]:text-secondary data-[selected]:border-secondary',
        'data-[selected]:drop-shadow-sm',
        'data-[focus-visible]:ring-2 data-[focus-visible]:ring-brand-600 data-[focus-visible]:ring-offset-1',
      ],
      [TabVariant.Button]: [
        'rounded-none',
        'bg-white text-quaternary',
        'hover:bg-brand-primary-alt hover:text-tertiary',
        'data-[selected]:bg-brand-primary-alt data-[selected]:text-brand-secondary',
        'data-[selected]:drop-shadow-sm',
        'data-[selected]:hover:bg-brand-primary-alt data-[selected]:hover:text-brand-secondary',
        'data-[focus-visible]:ring-2 data-[focus-visible]:ring-brand-600 data-[focus-visible]:ring-offset-1',
      ],
      [TabVariant.Underline]: [
        'flex-grow flex-shrink-0 basis-0 border-b-2 border-transparent gap-6 whitespace-nowrap',
        '!pt-0 !pb-6',
        'text-quaternary',
        'hover:text-tertiary',
        'data-[selected]:border-brand-primary data-[selected]:text-brand-secondary',
        'data-[focus-visible]:border-b-brand-600',
      ],
    },
    size: {
      [TabSize.Sm]: 'h-16 px-4 py-2 text-xs',
      [TabSize.Md]: 'h-18 px-6 py-4 text-sm',
      [TabSize.Lg]: 'h-20 px-8 py-5 text-base',
    },
  },
  compoundVariants: [
    {
      variant: TabVariant.Underline,
      size: TabSize.Sm,
      class: 'h-auto px-1 text-sm',
    },
    {
      variant: TabVariant.Underline,
      size: TabSize.Md,
      class: 'h-auto px-2 text-base',
    },
    {
      variant: TabVariant.Underline,
      size: TabSize.Lg,
      class: 'h-auto px-3 text-lg',
    },
  ],
  defaultVariants: {
    variant: TabVariant.Default,
    size: TabSize.Md,
  },
});
